/** Shared inline SVG icons used by CitationTooltip and the landing page demo */

export const DatabaseIcon = (
	<svg
		width='14'
		height='14'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
	>
		<ellipse
			cx='12'
			cy='5'
			rx='9'
			ry='3'
		/>
		<path d='M21 12c0 1.66-4 3-9 3s-9-1.34-9-3' />
		<path d='M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5' />
	</svg>
);

export const ClockIcon = (
	<svg
		width='12'
		height='12'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
	>
		<circle
			cx='12'
			cy='12'
			r='10'
		/>
		<polyline points='12 6 12 12 16 14' />
	</svg>
);
